/* eslint-disable */
import { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";

//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import HealthCenterCommonHeader from "../../HealthCenterCommonHeader/HealthCenterCommonHeader";
import SuccessStoriesHeader from "../Header/SuccessStoriesHeader";
//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import { mergeListById } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { ecosystemSlug } from "Config/Config";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import SuccessStoryFilterPopup from "../Popup/SuccessStoryFilterPopup";

const HealthCenterSuccessStoriesBody = () => {
  const { t } = useTranslation(); //for translation
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [storyList, setStoryList] = useState([]);

  //filter requirements
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]); // json filter query
  const [reloadData, setReloadData] = useState(false); // reload data
  const [isFilterReset, setIsFilterReset] = useState(false); // filter reset

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedStoryIds, setSelectedStoryIds] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedStoryId, setSelectedStoryId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all success stories
  const getAllSuccessStories = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_SUCCESS_STORIES +
        `?token=${token}&companyids=${params.id}&ecosystemslug=${ecosystemSlug}&userid=${userInfo._id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("url of all success stories------->", requestUrl);

      const response = await getData(requestUrl);

      console.log("success story list response------>", response);

      if (response.status) {
        setMessageType("success");
        setIsLoading(false);
        setStoryList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  // Update the rank value in the storyList state array
  const rankInputChangeHandler = (row, value) => {
    const updatedStoryList = [...storyList];
    const rowIndex = updatedStoryList.findIndex(
      (story) => story._id === row.original._id
    );
    if (rowIndex !== -1) {
      updatedStoryList[rowIndex].rank = value;
      setStoryList(updatedStoryList);
    }
  };

  //function for delete
  const deleteBulkStoryHandler = async () => {
    if (selectedStoryIds.length > 0) {
      try {
        const storyListToBeDelete = storyList.filter((item) =>
          selectedStoryIds.includes(item._id)
        );

        let storyData = {
          successstorieslist: storyListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_SUCCESS_STORY +
          `?token=${token}`;

        const response = await putData(requestURL, storyData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setStoryList((prevList) =>
              prevList.filter((item) => !selectedStoryIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one story");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from story
  const removeTagFromStory = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_SUCCESS_STORY;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedStoryId(null);
      }, 1000);
    }
  };

  const afterActionClose = (data = []) => {
    setStoryList((prevList) => mergeListById(prevList, data));
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllSuccessStories();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllSuccessStories();
      setReloadData(false);
    }
  }, [reloadData]);

  //columns for table
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Title",
        size: 200,
      },
      //tags column
      {
        accessorKey: "tagstring",
        header: t("Tags"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedStoryId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromStory([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedStoryId &&
                          selectedStoryId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedStoryIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "projectname",
        header: "Project Name",
        size: 200,
      },
      {
        accessorKey: "url",
        header: "URL",
        size: 200,
      },
      {
        accessorKey: "username",
        header: "Created By",
        size: 300,
        Cell: ({ row }) => (
          <div
            className={
              row.original.username === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.userimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.userimage
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block">{row.original.username}</span>
            </p>
          </div>
        ),
      },
      {
        accessorKey: "createddate",
        header: "Created Date",
        size: 200,
      },
    ],
    [selectedStoryId, selectedTagId]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedStoryIds(selectedIdsArray);
    } else {
      setSelectedStoryIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  return (
    <div id="content_wrapper">
      <section className="survey-wrapper bg-white pb-5">
        <TabsHeader
          commonHeaderObject={commonHeaderLinkLists(t)}
          activeOption="Health Centers"
        />
        <div className="container-fluid px-lg-5 px-md-4 px-3">
          {/* ---- common header ---- */}
          <HealthCenterCommonHeader moduleName="successstories" />

          {/* ---- success stories header ---- */}
          <SuccessStoriesHeader
            reloadData={getAllSuccessStories}
            selectedIds={selectedStoryIds}
          />

          {/* ---- table section ---- */}
          <div className="table-wrapper">
            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <MaterialReactTable
                columns={columns} // map columns to be displayed with api data,
                data={storyList} // data from api to be displayed
                enableGrouping
                enableRowSelection // enable showing checkbox
                getRowId={(row) => row._id} // map which value to select with row checkbox
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ rowSelection }} //pass our managed row selection state to the table to use
                enableRowActions // show the action column
                renderRowActionMenuItems={({ row }) => [
                  <MenuItem
                    key="edit"
                    //onClick={() => console.info(row.id)}
                  >
                    <Link
                      className="dropdown-item"
                      to={`/admin/successstories/save/${row.id}?healthcenterid=${params.id}`}
                    >
                      View Details
                    </Link>
                  </MenuItem>,
                  ,
                ]} // action columns menu items
                muiTableContainerProps={{
                  sx: {
                    maxHeight: "60vh",
                  },
                }}
                enableStickyHeader
              />
            )}
          </div>
        </div>

        <AddLabelModal
          moduleName="successstory"
          selectedIds={selectedStoryIds}
          afterTagModalClose={afterActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedStoryIds([]);
            setRowSelection({});
          }}
        />

        <DeleteWarningModal
          onCancelDelete={() => {
            setSelectedStoryIds([]);
            setRowSelection({});
          }}
          onDelete={deleteBulkStoryHandler}
          moduleName={t("success stories")}
        />

        <SuccessStoryFilterPopup
          moduleSlug="healthcentersuccessstories"
          jsonFilterQuery={jsonFilterQuery}
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        {/* ---- alert notification ---- */}
        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </section>
    </div>
  );
};

export default HealthCenterSuccessStoriesBody;
